<template>
  <div class="mt-4">
    <div class="d-flex align-center mb-4">
      <div class="subtitle-1  black--text">
        Configure Formula
      </div>
      <v-spacer></v-spacer>
    </div>
    <editor
      v-model="formula"
      @input="onInput"
      outlined
      class="mb-3"
      height="150px"
      :items="calculatedFields"
      ref="textarea"
      no-resize
    >
    </editor>
    <div v-if="errorMessage" class="red--text">
      {{ errorMessage }}
    </div>
    <div class="note" v-html="note"></div>
  </div>
</template>

<script>
import { fieldTypes } from "../../../assets/js/default";
import Editor from "../../templates/create/Editor.vue";
export default {
  components: { Editor },
  props: {
    value: String,
    item: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      dialog: false,
      isValid: false,
      field: "",
      formula: ""
    };
  },
  computed: {
    errorMessage() {
      const vm = this;
      let { isParsable, formula } = vm;
      if (!formula) return "Formula is required";
      if (!isParsable) return "Formula is invalid.";
      return "";
    },
    isParsable() {
      var FormulaParser = require("hot-formula-parser").Parser;
      var parser = new FormulaParser();
      const vm = this;
      let formula = vm.formatText;
      formula = vm.formatFormula(formula);
      let val = parser.parse(formula);
      console.log("error", val.error);
      return val.error == null;
    },
    formatText() {
      return this.formula;
    },
    note() {
      return `Note: Formula can be created using the Fields, numbers and these operators:  + - / * ( )
      <br/>Example: ( ({{ field }} + {{ field }} - {{ field}} ) * 0.5 ) / 2`;
    },
    fields() {
      return this.$store.getters.globalFields.filter(item => {
        return item.is_calculated == true;
      });
    },
    isOption() {
      const { field_type } = this.form;
      return field_type == "select" || field_type == "autocomplete";
    },
    types() {
      return fieldTypes.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    },
    title() {
      return this.id ? "Edit Calculated Field" : "Add New Calculated Field";
    },
    id() {
      return this.item.id;
    },
    global() {
      return this.$store.getters.globalFields.filter(item => {
        return item.is_used == true;
      });
    },
    service() {
      return this.$store.getters.serviceFields.filter(item => {
        return item.is_used == true;
      });
    },
    calculatedFields() {
      let global = this.global.map(item => {
        return item;
      });
      let service = this.service.map(item => {
        return item;
      });
      return global.concat(service);
    }
  },

  methods: {
    onInput() {
      this.$emit("input", this.formatText);
    },
    formatFormula(message) {
      let $ = window.$;
      let doc = document.createElement("div");
      doc.innerHTML = message;
      $(doc)
        .find("label")
        .each((i, item) => {
          $(item).html(0);
        });
      message = doc.innerText;
      console.log("formula", message);
      message = message.split("\n").join("<br/>");
      message = message.split("x").join("*");
      return message;
    },
    init(value) {
      const vm = this;
      vm.formula = value;
      vm.$refs.textarea.initFormula(value);
    }
  }
};
</script>

<style></style>
